import { ChangeEvent, useContext, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { AllSwitchablesData, SwitchableCollection } from "./functions";
import MassageChairsIndexCollection from "./index-collection";
import { SwitchableContext } from "./context";

function MassageChairsListing() {
  const { dataType } = useContext(SwitchableContext);
  const pageTitle =
    dataType === "chairs" ? "Jacuzzi MassageChairs" : "Jacuzzi Saunas";
  document.title = pageTitle;
  const { experiences, collections } = useLoaderData() as AllSwitchablesData;
  const [search, setSearch] = useState<string>("");
  return (
    <div className="page">
      <section className="brand3d-page-heading">
        <h1 className="brand3d-page-title">
          {pageTitle}
          {/* <a className="button" href={"#TBD"} target="_blank" rel="noreferrer">
            Download Spreadsheet
          </a> */}
        </h1>
        <p>
          <input
            type="text"
            name="search"
            className="search-field"
            placeholder="Search"
            value={search}
            onChange={(event: ChangeEvent<HTMLInputElement>): void => {
              setSearch(event.target.value);
            }}
          />
        </p>
      </section>
      {collections.map(
        (collection: SwitchableCollection): JSX.Element => (
          <MassageChairsIndexCollection
            key={`collection-${collection.name.replace(/\W/i, "-")}`}
            collection={collection}
            chairs={experiences}
            search={search}
          />
        ),
      )}
    </div>
  );
}

export default MassageChairsListing;
